import React, { useEffect, useState } from "react";
import { navigate } from "gatsby";
import loadable from "@loadable/component";
import { Container, Row, Col } from "react-bootstrap";
import { event } from "jquery";
//import { customStyles } from "../SearchResults/DropdownStyle";
//import './assets/styles/_index.scss';

const Select = loadable(() => import("react-select"));

function CustomPagination(props) {

    const changepagination = event => {
        //get sortby value

        console.log("event_target", event.target.value)
        props.handlePageClick(event.target.value - 1)
    }

    let page_options = [];
    for (let i = 1; i <= props?.nbPages; i++) {
        page_options.push({ value: i, label: i });
    }


    return (
        <div className={`load-more-wrap ${props.tag}`}>
            {props?.total &&

                <div className="d-flex align-items-center justify-content-between">
                    <button className={`results-btn d-flex align-items-center ${props?.current_page_number > 0 ? "" : "disabled"}`} disabled={props?.current_page_number > 0 ? "" : "disabled"} onClick={() => props.handlePageClick(props?.current_page_number - 1)}><i className="icon icon-results-back"></i> <span>Back</span></button>

                    <Col className="text-center col-8 pagination_dropdown">
                    Page:<select id="pagination-select" className="pagination-select" onChange={changepagination}>
                        {new Array(props?.nbPages).fill(null).map((_, index) => {
                        const page = index + 1;
                        return (
                            <option value={page}
                                selected={(props?.current_page_number) + 1 === page ? "selected" : ""}
                            >
                            {page}
                            </option>
                        );
                        })}
                    </select>of {props?.nbPages}
                    </Col>

                    <button className={`results-btn d-flex align-items-center ${(props?.current_page_number + 1) === props?.nbPages ? "disabled" : ""}`} disabled={(props?.current_page_number + 1) === props?.nbPages ? "disabled" : ""} onClick={() => props.handlePageClick(props?.current_page_number + 1)}><span>Next</span> <i className="icon icon-results-next"></i></button>
                </div>
            }
        </div>
    );
}

export default CustomPagination